import { Component, ViewChild, AfterViewInit, OnDestroy, } from '@angular/core';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../../../../shared/services/api.service';
import { CommonService } from '../../../../../shared/services/common.service';
import { PageEvent } from '@angular/material/paginator';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MSSIDCViewAllEventsDashboard } from '../../../../../shared/models/MSSIDCViewAllEventsDashboard';
import { MatDialog } from '@angular/material/dialog';
import { ViewmsmedocumentsComponent } from '../viewmsmedocuments/viewmsmedocuments.component';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { DatePipe } from '@angular/common';
import { UpdateEventDatePopupComponent } from '../update-event-date-popup/update-event-date-popup.component';
import { EventDateHistoryPopupComponent } from '../event-date-history-popup/event-date-history-popup.component';

import { UpdateUploadDocumentsPopupComponent } from '../update-upload-documents-popup/update-upload-documents-popup.component';
import { UpdateDocumentHistoryPopupComponent } from '../update-document-history-popup/update-document-history-popup.component';


@Component({
  selector: 'app-update-upload-documents',
  templateUrl: './update-upload-documents.component.html',
  styleUrl: './update-upload-documents.component.css'
})
export class UpdateUploadDocumentsComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();

  dataSource!: MatTableDataSource<MSSIDCViewAllEventsDashboard>
  displayedColumns: string[] = ['Sr.No', 'EventId', 'OrganisedBy', 'EventName', 'EventDate',
    'EventDuration', 'VenueDetails', 'Intervention', 'Component', 'NumberofParticipants', 'FocusSector', 'Status', 'EventURL', 'Download',


    'viewFeedback', 'AttendanceMarked', 'DocumentUploaded', 'Action']

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';
  reportData: any[] = [];
  allrecord: any[] = [];

  totalEvent: number = 0;
  pendingEvent: number = 0;
  approvedEvent: number = 0;
  rejectedEvent: number = 0;
  // Your full data source
  pageSizeOptions: number[] = [10, 20, 50, 100];  // Available page sizes
  isOutputReportSubmitted: boolean = false;




  DtoPagination =
    {
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": "",
      "TodayTommarow": "",
      "FromDate": "",
      "ToDate": ""
    }

  constructor(private datePipe: DatePipe, public dialog: MatDialog, private apiService: ApiService,
    private router: Router, private toastrService: ToastrService, public commonService: CommonService) {
    /*  this.LoadDetails();*/
  }

  form1 = new FormGroup({
    today: new FormControl(false),
    tomorrow: new FormControl(false),
    fromDate: new FormControl(null),
    toDate: new FormControl(null),
    searchControl: new FormControl('', [
      Validators.pattern(this.commonService.searchFilter)
    ])
    // usertypeid: new FormControl('', [Validators.nullValidator]),
    // description: new FormControl('')
  });


  ngOnInit(): void {
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchCol = this.commonService.searchText;


    //this.loadReport(this.DtoPagination);

  }

  ngAfterViewInit() {
    this.loadData();

  }


  loadData() {
    if (!this.pagination) return;

    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;
          this.DtoPagination.ToDate = this.DtoPagination.ToDate ?? "";
          this.DtoPagination.FromDate = this.DtoPagination.FromDate ?? "";
          this.DtoPagination.TodayTommarow = this.DtoPagination.TodayTommarow ?? "";

          return this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTOTALEVENTS, this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
            //this.isOutputReportSubmitted = resp.OutputReportSubmitted;
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.dataSource = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }


  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  loadReport(DtoPagination: any): void {
    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTOTALEVENTS, DtoPagination).subscribe(
      (data) => {
        this.length = data['totalRecords']
        this.reportData = data.data;


      },
      (error: any) => {
        console.error('Error fetching report data:', error);
      }
    );
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error('Download failed:', error);
      }
    });
  }


  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];

  //onPageChange(event: any) {
  //  this.DtoPagination.PageNumber = event.pageIndex + 1;
  //  this.loadReport(this.DtoPagination);
  //}


  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    //this.loadReport(this.DtoPagination);
    this.loadData();
  }


  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.SearchCol = this.commonService.searchText;
    this.DtoPagination.PageNumber = 1;
    //this.loadReport(this.DtoPagination);
    this.loadData();
  }

  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');
    const fromDateControl = this.form1.get('fromDate');
    const toDateControl = this.form1.get('toDate');

    // 👉 Clear Today/Tomorrow flags
    this.form1.patchValue({
      today: false,
      tomorrow: false
    });
    this.DtoPagination.TodayTommarow = "";

    // 👉 Validate From/To date
    if (fromDateControl?.value && toDateControl?.value) {
      if (fromDateControl.value > toDateControl.value) {
        this.toastrService.error('From Date should be less than To Date.');
        this.form1.patchValue({
          fromDate: null,
          toDate: null
        });
        this.form1.setErrors({ dateRangeInvalid: true });
        return; // stop here, do not search
      } else {
        // clear error if previously set
        if (this.form1.hasError('dateRangeInvalid')) {
          this.form1.setErrors(null);
        }
      }
    }

    // 👉 Proceed with search
    if ((searchControl?.value && searchValue.trim() !== '')
      || (fromDateControl?.value && toDateControl?.value)) {

      this.DtoPagination.SearchTerm = searchValue.trim();
      this.DtoPagination.SearchCol = this.commonService.searchText;

      this.DtoPagination.FromDate = fromDateControl?.value
        ? this.datePipe.transform(fromDateControl.value, 'yyyy-MM-dd')!
        : '';
      this.DtoPagination.ToDate = toDateControl?.value
        ? this.datePipe.transform(toDateControl.value, 'yyyy-MM-dd')!
        : '';

      this.loadData();
    } else {
      searchControl?.markAsTouched();
    }
  }

  resetPage() {
    this.DtoPagination = {
      PageNumber: 1,
      PageSize: 20,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
      TodayTommarow: "",
      FromDate: "",
      ToDate: ""
    };

    this.loadData();
  }


  DownloadUpldDocs(UniqueEventId: string): void {
    const dialogRef = this.dialog.open(ViewmsmedocumentsComponent, {
      width: '1200px',
      data: { UniqueEventId: UniqueEventId }
    });

    dialogRef.afterClosed().subscribe(result => { });
  }

  exportToExcel(): void {
    const fileName = 'Event_List.xlsx';

    const DtonullPagination = {
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: "",
      SortDirection: "",
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
      TodayTommarow: "",
      FromDate: "",
      ToDate: ""
    };

    this.apiService.getRequest(API_ENDPOINTS.MSSIDC.GETTOTALEVENTS, DtonullPagination)
      .subscribe(result => {
        if (result.status && result.data && result.data.length > 0) {
          this.allrecord = result.data;

          const excelData = this.allrecord.map((item, index) => ({
            'Sr. No': index + 1,
            'Organised By': item.OrganisedBy,
            'Event Name': item.EventName,
            'Event Date': item.EventDate,
            'Event Duration': item.EventDuration,
            'Venue Details': item.VenueDetails,
            'Intervention': item.Intervention,
            'Component': item.Component,
            'No. of Participants': item.NumberofParticipants,
            'Focus Sector': item.FocusSector,
            'Status': item.Status,
            'AttendanceMarked': item.AttendanceMarked,
            'DocumentUploaded': item.DocumentUploaded,
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          worksheet['!cols'] = [
            { wch: 10 }, // Sr. No
            { wch: 20 }, // Organised By
            { wch: 30 }, // Event Name
            { wch: 15 }, // Event Date
            { wch: 15 }, // Event Duration
            { wch: 30 }, // Venue Details
            { wch: 20 }, // Intervention
            { wch: 35 }, // Component
            { wch: 10 }, // No. of Participants
            { wch: 20 }, // Focus Sector
            { wch: 10 }, // Status
            { wch: 15 }, // AttendanceMarked
            { wch: 15 }, // DocumentUploaded
          ];

          const workbook: XLSX.WorkBook = {
            Sheets: { 'Event List': worksheet },
            SheetNames: ['Event List'],
          };

          const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastrService.success('Excel exported successfully!');
        } else {
          this.toastrService.error('No data available to export.');
        }
      }, error => {
        this.toastrService.error('Failed to fetch data for export.');
      });
  }

  onOutputReport(iaid: string, eventid: string) {
    this.router.navigate(['/eventoutputreport', iaid, eventid]);
  }

  convertToDateObjectNew(inputDate: string): Date {
    const [day, month, year] = inputDate.split(" ")[0].split("/");
    return new Date(Number(year), Number(month) - 1, Number(day), 0, 0, 0);
  }

  // Format date
  formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  isBeforeToday(dateString: string): boolean {

    const eventDate = this.convertToDateObjectNew(dateString)
    //const today = this.getTodayMidnight();

    const toda = new Date();
    const today = this.formatDate(toda);

    //if (dateString.replaceAll('/', '-') < today)
    //  this.actionButton = 'View';
    //else
    //  this.actionButton = 'Edit';

    return eventDate < toda; //dateString.replaceAll('/', '-') < today;
  }

  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

  ViewMsMe(eventid: string) {
    this.router.navigate(['/viewEnrolledMsMe', eventid]);
  }

  onViewFeedback(eventid: string): void {
    this.router.navigate(['/viewFeedbacksListmssidc', eventid]);
  }

  editEvent(uniqueEventId: string): void {
    this.router.navigate(['/reports/viewevent', uniqueEventId, 'edit']);
  }
  action(uniqueEventId: string): void {
    this.router.navigate(['/reports/viewevent', uniqueEventId]);
  }

  onButtonClick(selected: 'today' | 'tomorrow') {
    this.form1.patchValue({
      today: selected === 'today',
      tomorrow: selected === 'tomorrow',
      fromDate: null,
      toDate: null,
      searchControl: null
    });

    const todayControl = this.form1.get('today');
    const tomorrowControl = this.form1.get('tomorrow');
    let selectedDate: Date | null = null;

    if (todayControl?.value) {
      selectedDate = new Date(); // Today
    } else if (tomorrowControl?.value) {
      selectedDate = new Date();
      selectedDate.setDate(selectedDate.getDate() + 1); // Tomorrow
    }
    this.DtoPagination.TodayTommarow = selectedDate
      ? selectedDate.toISOString().slice(0, 10)! // Format: YYYY-MM-DD
      : '';

    this.loadData();
  }

  dateRangeValidator(group: AbstractControl): ValidationErrors | null {
    const from = group.get('fromDate')?.value;
    const to = group.get('toDate')?.value;

    if (from && to && from > to) {
      return { dateRangeInvalid: true };
    }
    return null;
  }

  onDateChange(): void {
    // when user selects a date, reset today/tomorrow buttons
    this.form1.patchValue({
      today: false,
      tomorrow: false
    });

    // Optional: check validity immediately
    const from = this.form1.get('fromDate')?.value;
    const to = this.form1.get('toDate')?.value;

    if (from && to && from > to) {
      this.form1.setErrors({ dateRangeInvalid: true });
    } else {
      // clear error if valid
      if (this.form1.hasError('dateRangeInvalid')) {
        this.form1.setErrors(null);
      }
    }
  }

  selectedDate: string = '';
  selectedElement: any;
  EventName: any;

  onChangeDate(element: any): void {



    this.EventName = element.EventName

    const dialogRef = this.dialog.open(UpdateEventDatePopupComponent, {
      width: '400px',
      data: element   // pass full row data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        element.updatedDate = result;
        console.log('Updated Date:', element);
        this.loadData();
        // 👉 Call API here if needed
      }
    });

  }

  onChangeDocuments(element: any): void {

    const dialogRef = this.dialog.open(
      UpdateUploadDocumentsPopupComponent,
      {
        width: '1000px',
        maxWidth: '95vw',
        height: '80vh',
        data: element
      }
    );

    dialogRef.afterClosed().subscribe(result => {

      if (result) {

        this.loadData();

      }

    });

  }
  onAudit(element: any): void {
    const dialogRef = this.dialog.open(UpdateDocumentHistoryPopupComponent, {
      width: '80vw',          // 🔥 responsive width
      maxWidth: '95vw',       // prevent overflow
      height: '80vh',         // 🔥 fixed height
      panelClass: 'custom-dialog-container', // optional styling

      // 🟢 'data' ऑब्जेक्टच्या आत जुना डेटा आणि popupType दोन्ही एकत्र मॅप केले आहेत
      data: {
        ...element,
        popupType: 'document'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        element.updatedDate = result;
        this.loadData();
      }
    });
  }
}
